interface Props {
  onDonate: () => void;
}

export default function CommunityDonationBanner({ onDonate }: Props) {
  return (
    <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-pink-400 via-rose-400 to-pink-500">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/4 pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>

      <div className="relative flex flex-col md:flex-row items-center justify-between px-6 md:px-10 py-8 gap-6">
        {/* Left: hearts decoration */}
        <div className="hidden lg:flex flex-col items-center gap-3 flex-shrink-0">
          <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full">
            <i className="ri-heart-fill text-white text-3xl"></i>
          </div>
          <div className="flex gap-2">
            <div className="w-8 h-8 flex items-center justify-center bg-white/15 rounded-full">
              <i className="ri-heart-fill text-white text-sm"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center bg-white/15 rounded-full">
              <i className="ri-heart-fill text-white text-sm"></i>
            </div>
          </div>
        </div>

        {/* Center: text */}
        <div className="text-white text-center md:text-left flex-1 max-w-xl">
          <div className="flex items-center gap-2 mb-2 justify-center md:justify-start">
            <i className="ri-heart-fill text-white/80 text-sm"></i>
            <span className="text-white/90 text-xs font-bold uppercase tracking-widest">Community Charity</span>
          </div>
          <h3 className="text-xl md:text-2xl font-bold leading-tight mb-2">
            Rich or Not — Every Donation Counts
          </h3>
          <p className="text-white/85 text-sm leading-relaxed mb-3">
            If you are blessed with abundance, welcome to donate for infants around the world who need love, milk, warm clothes, and care. Together we can change lives.
          </p>
          <div className="flex flex-wrap gap-3 justify-center md:justify-start text-xs text-white/80">
            <span className="flex items-center gap-1"><i className="ri-drop-line"></i> Milk &amp; Nutrition</span>
            <span className="flex items-center gap-1"><i className="ri-shirt-line"></i> Warm Clothes</span>
            <span className="flex items-center gap-1"><i className="ri-heart-pulse-line"></i> Medical Care</span>
            <span className="flex items-center gap-1"><i className="ri-home-heart-line"></i> Safe Shelter</span>
          </div>
        </div>

        {/* Right: CTA */}
        <div className="flex flex-col items-center gap-3 flex-shrink-0">
          <button
            onClick={onDonate}
            className="px-7 py-3 bg-white hover:bg-pink-50 text-rose-500 font-bold rounded-xl text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-heart-fill text-rose-500"></i> Donate for Infants
          </button>
          <div className="flex items-center gap-2">
            <div className="flex -space-x-2">
              {["MT", "JK", "LW", "CM", "AB"].map((init) => (
                <div key={init} className="w-7 h-7 flex items-center justify-center rounded-full bg-white/30 text-white text-xs font-bold border-2 border-white/50">
                  {init}
                </div>
              ))}
            </div>
            <span className="text-white/80 text-xs">+312 donors this month</span>
          </div>
        </div>
      </div>
    </div>
  );
}
